var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.Pokaz)?_c('div',{staticClass:"LiniaFlexLeft"},[_c('div',{staticClass:"Kropki"},[_c('img',{staticClass:"Kropka",attrs:{"src":_vm.Obraz,"alt":""}})]),_c('div',[_vm._v(" "+_vm._s(_vm.Dane.Tekst)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }